import type { NativeApi } from "@t3tools/contracts";

import { isDashboardsOnly } from "./dashboardsOnly";
import { createWsNativeApi, disposeWsNativeApi } from "./wsNativeApi";

let cachedApi: NativeApi | undefined;

export function readNativeApi(): NativeApi | undefined {
  if (typeof window === "undefined") return undefined;
  if (cachedApi) return cachedApi;

  if (window.nativeApi) {
    cachedApi = window.nativeApi;
    return cachedApi;
  }

  // A dashboards preview does not proxy /ws, so constructing the transport here
  // would only produce a socket that retries forever against a 404.
  if (isDashboardsOnly()) return undefined;

  cachedApi = createWsNativeApi();
  return cachedApi;
}

export function ensureNativeApi(): NativeApi {
  const api = readNativeApi();
  if (!api) {
    throw new Error(
      isDashboardsOnly()
        ? "Operator sessions are unavailable in a dashboards preview."
        : "Native API not found",
    );
  }
  return api;
}

export function resetNativeApi(): void {
  disposeWsNativeApi();
  cachedApi = undefined;
}
